import { FlowStep } from '@/interfaces/requirement';
import { BoxColors } from '@/shared/person-card/person-card.component';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';
import { deofuscate } from '@/utils/obfuscation';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

@Component({
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css'],
})
export class DetailComponent implements OnInit {
  CardBoxColors = BoxColors;

  id: number = 0;
  userId: number = 0;
  requirementStatus?: FlowStep[];

  constructor(
    private route: ActivatedRoute,
    private store: Store<StoreState>,
    private _location: Location,
  ) {
    getCurrentUserData(this.store).subscribe({
      next: (userData) => {
        this.userId = userData.id;
      },
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe(({ ofuscatedData }) => {
      const params = deofuscate(ofuscatedData);
      this.id = +params.id;
    });
  }

  goBack() {
    this._location.back();
  }
}
